module.exports = __webpack_public_path__ + "static/img/IMG_20160820_185538.639010e2.jpg";